export default function ContactBlock() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="max-w-4xl">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-6 md:mb-8">
            Notre atelier
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {/* Info card */}
            <div className="bg-rose-50 rounded-2xl p-6 md:p-8 border border-rose-100">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0">
                    <i className="ri-map-pin-line text-plum text-lg" />
                  </div>
                  <div>
                    <p className="font-semibold text-base md:text-lg text-plum-dark">Adresse</p>
                    <p className="text-sm md:text-base text-plum-dark/70">82 rue de Heidenberg</p>
                    <p className="text-sm md:text-base text-plum-dark/70">67200 Strasbourg</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0">
                    <i className="ri-phone-line text-plum text-lg" />
                  </div>
                  <div>
                    <p className="font-semibold text-base md:text-lg text-plum-dark">Téléphone</p>
                    <a href="tel:0374471036" className="text-sm md:text-base text-plum-dark/70 hover:text-coral transition-colors">
                      03 74 47 10 36
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0">
                    <i className="ri-time-line text-plum text-lg" />
                  </div>
                  <div>
                    <p className="font-semibold text-base md:text-lg text-plum-dark">Horaires</p>
                    <p className="text-sm md:text-base text-plum-dark/70">Lundi — Samedi : 8h — 18h</p>
                  </div>
                </div>
              </div>
              <a
                href="tel:0374471036"
                className="inline-flex items-center justify-center gap-2 bg-coral text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-coral-light transition-colors mt-6 w-full"
              >
                <i className="ri-phone-line" />
                Appeler le 03 74 47 10 36
              </a>
            </div>
            {/* Google Map */}
            <div className="rounded-2xl overflow-hidden border border-rose-100 h-[300px] md:h-auto">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2639.5!2d7.7!3d48.58!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4796c84b0e0e0e0e%3A0x0!2zODIgcnVlIGRlIEhlaWRlbmJlcmcsIDY3MjAwIFN0cmFzYm91cmc!5e0!3m2!1sfr!2sfr!4v1"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Carte DF PRO - 82 rue de Heidenberg, 67200 Strasbourg"
                aria-label="Carte localisation atelier DF PRO Strasbourg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}